import {
    CookieType,
    ThirdPartyScript,
} from "web/script/analytics/third_party_scripts/third-party-scripts";
import { load as loadKlarnaOnsiteService } from "web/script/embedded/klarnaOnsiteService";
import environment from "web/script/modules/environment";

export class KlarnaOnsiteService implements ThirdPartyScript {
    cookieType: CookieType = "analytics" as CookieType;
    loadScript;
    constructor() {
        this.loadScript = environment.getFeature("checkout_klarna_messaging");
    }
    async load(): Promise<void> {
        const country = environment.get("country");
        if (!this.loadScript || !["US", "GB"].includes(country)) {
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            loadKlarnaOnsiteService(country);
            resolve();
        });
    }
}
